import React from 'react';
import { UserContext } from './UserContext';
import { Entity } from '../types/apiTypes';

export const DemoUserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const mockUserRecord = {
    customer_id: 'demo-customer-id',
    status: 'pre_active',
    userType: Entity.Customer,
    business_name: 'Demo Trucking Co.',
    tach_member_id: 'TACH-DEMO',
    driver: {
      first_name: 'Demo User',
      last_name: 'User',
    },
    is_cash_advance_active: false,
  } as any;

  return (
    <UserContext.Provider
      value={{
        userRecord: mockUserRecord,
        setUserRecord: () => {},
        userRole: Entity.Customer,
        setUserRole: () => {},
        userId: 'demo-customer-id',
        userType: Entity.Customer,
        logout: () => {
          window.location.href = '/login';
        },
        refetchUser: async () => {},
        isLoadingUser: false,
        isLoggingOut: false,
        userFetchOutcome: 'found',
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
